import React from 'react';
import { Table, TableBody } from '@material-ui/core';
import { Loader } from 'kangarootime-ui';
import Header from './Header';
import Row from './Row';

const EmployeeSchedulesTable = ({
  employees,
  isLoading,
  employeeSchedules,
  visibleDates,
  employeeTimeOffRequests
}) => {
  return (
    <Loader loading={isLoading}>
      <Table className='schedulingTable'>
        <Header employeeCount={employees.length} weekDates={visibleDates} />
        <TableBody>
          { employees.map(employee => (
            <Row
              key={employee.id}
              employee={employee}
              schedules={employeeSchedules[employee.id]}
              datesInWeek={visibleDates}
              timeOffRequests={employeeTimeOffRequests[employee.id]}
            />
          ))}
        </TableBody>
      </Table>
    </Loader>
  );
};

export default EmployeeSchedulesTable;
